import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const createGroup = (payload) => {
  const url = getUrl("listGroup");
  return trackPromise(Call.post(url, payload));
};
export const editGroup = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listGroup");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.patch(patchUrl, data));
};

export const getGroups = (pageUrl) => {
  const groupUrl = pageUrl ? pageUrl : getUrl("listGroup");
  return trackPromise(Call.get(groupUrl));
};

export const listPermissions = () => {
  const list_permissions = getUrl("listPermissions");
  return trackPromise(Call.get(list_permissions));
};

export const listUser = () => {
  const list_permissions = getUrl("listUsers");
  return trackPromise(Call.get(list_permissions));
};

export const deleteGroup = (id = "") => {
  const url = getUrl("listGroup");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};
